import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { CONFIG_URLS_API } from 'src/environments/config-envs';

export interface BloqueioHorarioRequest {
  Guid: string;
  CodFrota?: number;
  CodSubfrota?: number;
  CodVeiculo?: number;
  CodEntidadeBloqueada?: number;
  CodTipoEntidadeBloqueada?: number;
}

export interface RemoveBlockHourRequest extends BloqueioHorarioRequest {
  HoraInicio: string;
  HoraFim: string;
  Segunda: boolean;
  Terca: boolean;
  Quarta: boolean;
  Quinta: boolean;
  Sexta: boolean;
  Sabado: boolean;
  Domingo: boolean;
  CodBloqueio: number;
}

export interface AddBlockHourRequest extends BloqueioHorarioRequest {
  HoraInicio: string;
  HoraFim: string;
  Segunda: boolean;
  Terca: boolean;
  Quarta: boolean;
  Quinta: boolean;
  Sexta: boolean;
  Sabado: boolean;
  Domingo: boolean;
}

export interface BloqueioHorarioResponse {
  sucesso: boolean;
  retorno: Array<{
    codBloqueio: number;
    codEntidadeBloqueada: number;
    horaInicio: string;
    horaFim: string;
    domingo: boolean;
    segunda: boolean;
    terca: boolean;
    quarta: boolean;
    quinta: boolean;
    sexta: boolean;
    sabado: boolean;
    excluir: boolean;
  }>;
  mensagens: string[];
}

@Injectable({
  providedIn: 'root'
})
export class AbastecimentoHorarioService {
  private readonly httpOptions = { 
    headers: {
      'Content-Type': 'application/json'
    }
  };

  constructor(private http: HttpClient) { }

  getRestrictions(
    userGuid: string, 
    codEntidade: number, 
    tipoEntidade: 'frota' | 'subfrota' | 'veiculos',
    codSubfrota?: number
  ): Observable<{ sucesso: boolean, retorno: any[] }> {
    const url = `${environment.host_ctf_service}${CONFIG_URLS_API.API_ConsultaHorarios}/listar`;
    
    const body: BloqueioHorarioRequest = {
      Guid: userGuid
    };

    switch (tipoEntidade) {
      case 'frota':
        body.CodFrota = codEntidade;
        break;
      case 'subfrota':
        body.CodSubfrota = codEntidade;
        break;
      case 'veiculos':
        body.CodVeiculo = codEntidade;
        if (codSubfrota) {
          body.CodSubfrota = codSubfrota;
        }
        break;
    }

    return this.http.post<BloqueioHorarioResponse>(url, body, this.httpOptions)
      .pipe(
        map(response => ({
          sucesso: response.sucesso,
          retorno: response.retorno.map(item => ({
            codBloqueio: item.codBloqueio,
            codEntidadeBloqueada: item.codEntidadeBloqueada,
            horaInicio: item.horaInicio,
            horaFim: item.horaFim,
            domingo: item.domingo,
            segunda: item.segunda,
            terca: item.terca,
            quarta: item.quarta,
            quinta: item.quinta,
            sexta: item.sexta,
            sabado: item.sabado,
            status: item.excluir ? 'Inativo' : 'Ativo'
          }))
        }))
      );
  }

  deleteHour(
    userGuid: string, 
    request: RemoveBlockHourRequest, 
    tipoEntidade: 'frota' | 'subfrota' | 'veiculos'
  ): Observable<BloqueioHorarioResponse> {
    const url = `${environment.host_ctf_service}${CONFIG_URLS_API.API_ConsultaHorarios}/remover`;
    return this.http.request<BloqueioHorarioResponse>('delete', url, {
      body: request,
      headers: this.httpOptions.headers
    });
  }

  addHour(
    userGuid: string, 
    request: AddBlockHourRequest, 
    tipoEntidade: 'frota' | 'subfrota' | 'veiculos'
  ): Observable<BloqueioHorarioResponse> {
    const url = `${environment.host_ctf_service}${CONFIG_URLS_API.API_ConsultaHorarios}/incluir`;
    return this.http.post<BloqueioHorarioResponse>(url, request, this.httpOptions);
  }
}